import { Link } from "react-router-dom";
import type { Chapter } from "@/data/chapters";

export default function ChapterCard({ chapter }: { chapter: Chapter }) {
  return (
    <Link
      to={`/detail/${chapter.id}`}
      className="group surface-card block overflow-hidden transition-colors duration-300 hover:border-accent-500/60"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <img
          src={chapter.cover}
          alt={`第 ${chapter.index} 章 ${chapter.title} 章节封面`}
          title={`色戒无删减版 ${chapter.title} 剧情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/25 to-transparent" />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-2.5 py-1 font-label text-[11px] tracking-wide text-foreground-950">
          {chapter.segment}
        </span>
        <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/70 px-2.5 py-1 font-label text-[11px] text-foreground-900 backdrop-blur">
          <i className="ri-time-line text-xs leading-none" />
          {chapter.duration} 分钟
        </span>
        <div className="absolute inset-x-3 bottom-3 flex items-center justify-between">
          <span className="font-heading text-lg text-foreground-950">第 {chapter.index} 章</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-full border border-foreground-950/25 bg-background-50/40 text-foreground-950 backdrop-blur transition-colors group-hover:border-accent-500 group-hover:bg-accent-500 group-hover:text-background-50">
            <i className="ri-play-fill text-sm leading-none" />
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base text-foreground-950 transition-colors group-hover:text-accent-400 md:text-[17px]">
          {chapter.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{chapter.excerpt}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {chapter.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}